import "./brokerCryptoTestFooter.scss";
import React from "react";
import PropTypes from "prop-types";
const { FormattedText } = require('core/i18n').i18n;

import { OKLink } from "commonsComponents/OKLink";
import { CryptoButton } from "../brokerCryptoButton/brokerCryptoButton";
import { taggingEventHandled } from 'utilities/taggingEventHandled';

import { PROC_BROKER_CONVENIENCE_CRYPTO_TEST } from 'utilities/tagging';
import { CRYPTO_TEST_STATES } from "mifid/constants/constants";
const { TEST_IN_PROGRESS, TEST_SUMMARY, READ_DOCUMENTATION } =
    CRYPTO_TEST_STATES;

export default function brokerCryptoTestFooter({
    testState,
    goToPreviousQuestion,
    currentQuestionIndex,
    cancelPath,
    insertTestWithoutToken,
    openModalDocumentation,
    history,
    goToNextStep,
    currentQuestionIsAwnsered,
    immBrokerConvenienceMiFIDTest,
    getCurrentTestScore,
}) {

    const handleCancel = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'cancelButton');
        history.push(cancelPath);
    };

    const handleGoToPreviousQuestion = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'backButton', { pathname: history.location.pathname });
        goToPreviousQuestion();
    };

    const handleGoToNextQuestion = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'nextButton', { pathname: history.location.pathname });
        goToNextStep();
    }

    const handleInsertTestWithoutToken = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'confirmAnswers', { pathname: history.location.pathname });
        insertTestWithoutToken();
    };

    const handleOpenModalDocumentation = () => {
        taggingEventHandled(PROC_BROKER_CONVENIENCE_CRYPTO_TEST, 'readDocumentation', { pathname: history.location.pathname });
        openModalDocumentation();
    };

    const testStateContent = {
        [TEST_IN_PROGRESS]: (
            <div className="crypto-test-footer crypto-test-footer__in-progress">
                <div>
                    <OKLink
                        extraClass="crypto-test-footer__link"
                        onClick={()=>handleCancel()}
                    >
                        <FormattedText value="brokerCryptoTest-buttonCancel" />
                    </OKLink>
                </div>
                <div>
                    {!!currentQuestionIndex && (
                        <CryptoButton
                            variant="secondary"
                            onClick={() => handleGoToPreviousQuestion()}
                        >
                            <FormattedText className="crypto-test-footer__button-label" value="brokerCryptoTest-buttonBack" />
                        </CryptoButton>
                    )}
                    <CryptoButton
                        extraClass='crypto-test-footer__continue-button'
                        variant="primary"
                        onClick={() => handleGoToNextQuestion()}
                        disabled={!currentQuestionIsAwnsered}
                    >
                        <FormattedText value="broker-convenienceMifidSuccessContinueCTA" />
                    </CryptoButton>
                </div>
            </div>
        ),
        [TEST_SUMMARY]: (
            <div className="crypto-test-footer crypto-test-footer__summary">
                <div>
                    <OKLink
                        extraClass="crypto-test-footer__link"
                        onClick={()=>handleCancel()}
                    >
                        <FormattedText value="brokerCryptoTest-buttonCancel" />
                    </OKLink>
                </div>
                <div className="crypto-test-footer__summary-right-buttons">
                    <CryptoButton
                        variant="secondary"
                        onClick={() => handleGoToPreviousQuestion()}
                    >
                        <FormattedText className="crypto-test-footer__button-label" value="brokerCryptoTest-buttonBack" />
                    </CryptoButton>
                    <CryptoButton
                        variant="primary"
                        onClick={() => handleInsertTestWithoutToken()}
                        disabled={immBrokerConvenienceMiFIDTest.get('loading')}
                    >
                        <FormattedText className="crypto-test-footer__button-label" value="brokerCryptoTest-buttonConfirmResponses" />
                    </CryptoButton>
                </div>
            </div>
        ),
        [READ_DOCUMENTATION]: (
            <div className="crypto-test-footer crypto-test-footer__documentation">
                <div>
                    <OKLink
                        extraClass="crypto-test-footer__link"
                        onClick={()=>handleCancel()}
                    >
                        <FormattedText value="brokerCryptoTest-buttonCancel" />
                    </OKLink>
                </div>
                <div>
                    <CryptoButton
                        variant="primary"
                        onClick={() => handleOpenModalDocumentation()}
                        disabled={
                            immBrokerConvenienceMiFIDTest.getIn(["test", "cryptoDocumentation", "cryptoDocumentationSignLoading"]) ||
                            immBrokerConvenienceMiFIDTest.getIn(["test", "cryptoDocumentation", "cryptoOperationProcessIdLoading"])
                        }
                    >
                        <FormattedText className="crypto-test-footer__button-label" value="brokerCryptoTest-buttonReadDocumentation" />
                    </CryptoButton>
                </div>
            </div>
        ),
    };

    return testStateContent[testState] || null;
}

brokerCryptoTestFooter.propTypes = {
    testState: PropTypes.oneOf([
        TEST_IN_PROGRESS,
        TEST_SUMMARY,
        READ_DOCUMENTATION,
    ]).isRequired,
    goToNextStep: PropTypes.func.isRequired,
    goToPreviousQuestion: PropTypes.func.isRequired,
    currentQuestionIndex: PropTypes.number.isRequired,
    cancelPath: PropTypes.string.isRequired,
    insertTestWithoutToken: PropTypes.func.isRequired,
    openModalDocumentation: PropTypes.func.isRequired,
    getCurrentTestScore: PropTypes.func.isRequired,
    currentQuestionIsAwnsered: PropTypes.bool,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
};
